<template>
  <div id="housingLeftTwo" class="echarts"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,

  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { carAlarm } from "@/api/dataAnalysis/carAnalysis.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsNameList: [],
      echartsValueList: [],
    });
    const refData = toRefs(data);
    const numberall = async () => {
      const res = await carAlarm();
      if (res.code == 0) {
        res.data.forEach((element) => {
          data.echartsNameList.push(element.name);
          data.echartsValueList.push(element.value);
        });
      }
    };

    onMounted(async () => {
      // echarts项目初始化
      await numberall();
      const myChart = echarts.init(document.getElementById("housingLeftTwo"));
      myChart.setOption({
        grid: {
          top: 40,
          left: 50,
          right: 30,
          bottom: 50,
          // containLabel: true
        },
        xAxis: {
          data: data.echartsNameList,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#08598f", // 横坐标线条颜色
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            // 网格线
            lineStyle: {
              color: "#08598f",
              type: "dashed", // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, // 隐藏或显示
          },
        },
        series: [
          {
            data: data.echartsValueList,
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "#f56463", // 折点颜色
                lineStyle: {
                  color: "#f56463", // 折线颜色
                },
              },
            },
          },
        ],
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });
  },
});
</script>
<style lang="scss" scoped>
#housingLeftTwo {
  width: 100%;
  height: 90%;
}
</style>
